export * from './interval/interval-decorator';
export * from './timeout/timeout-decorator';



// WEBPACK FOOTER //
// ./src/main.ts